import React from 'react';

import {MERCHANT_ACCOUNT_SETTINGS_SUBMENU} from "../../../../constants/links";
import {SecondLayerNavigation} from "../../../helpers/Menu";

import Profile from './components/Profile';
import Authorisation from './components/Authorisation';
import Notifications from './components/Notifications';
import Users from './components/Users';

module.exports = () => {
  return (
    <SecondLayerNavigation
      links={MERCHANT_ACCOUNT_SETTINGS_SUBMENU}
      views={{
        profile: Profile,
        auth: Authorisation,
        notifications: Notifications,
        users: Users,
      }}
    />
  )
};
